import { Component, inject } from '@angular/core';
import { Dialog } from '../dialog';
import {
  EEntityType,
  ERelationType,
  ITicket,
  NamedTariffProductDefinition,
} from '@web/dtos';
import { ToTicketTilePipe } from '../../../pipes/to-ticket-tile/to-ticket-tile.pipe';
import { ButtonComponent } from '../../feedback/button/button.component';
import { DialogComponent } from '../dialog/dialog.component';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { Router } from '@angular/router';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { ERoute } from '../../../constants/routes.enum';

@Component({
  selector: 'aw-direct-ticket-remove-from-shopping-cart-dialog',
  imports: [
    ToTicketTilePipe,
    ButtonComponent,
    DialogComponent,
    FilterTextsPipe,
    LanguagePipe,
  ],
  templateUrl:
    './direct-ticket-remove-from-shopping-cart-dialog.component.html',
})
export class DirectTicketRemoveFromShoppingCartDialog extends Dialog<{
  index: number;
  name: string;
  ticket: ITicket;
  productDefinition: NamedTariffProductDefinition;
}> {
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  private readonly shoppingCart: ShoppingCartService =
    inject(ShoppingCartService);
  private readonly router: Router = inject(Router);

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  public removeTicket(): void {
    if (this.data.index <= 0) {
      this.shoppingCart.removeTicket(0);
      this.router.navigate([`/${ERoute.directTickets}`]);
    } else {
      this.shoppingCart.removeTicket(this.data.index);
    }
    this.dialogRef.close();
  }
}
